import { css } from '@emotion/react'

export const buttonVariants = {
  solid: css`
    background-color: var(--button-color);
    color: var(--button-text-color);
    border: 1px solid var(--button-border-color);
    fill: var(--button-text-color);
    stroke: var(--button-text-color);
  `,
  outlined: css`
    background-color: transparent;
    border: 1px solid var(--button-border-color);
    color: var(--button-color);
    fill: var(--button-color);
    stroke: var(--button-color);
  `,
  ghost: css`
    background-color: transparent;
    color: var(--button-color);
    border: none;
    fill: var(--button-color);
    stroke: var(--button-color);

    g,
    path {
      stroke: var(--button-color);
    }
  `,
  card: css`
    color: var(--neutral-950);
    fill: var(--neutral-950);
    stroke: var(--neutral-950);
    border: 0;
    background-color: transparent;
    justify-content: right;
    padding: 0;
  `,
}

export const buttonTheme = {
  background_is_darker: css`
    --button-color: var(--neutral-950);
    --button-text-color: var(--beige-100);
    --button-border-color: var(--neutral-950);
  `,
  background_is_lighter: css`
    --button-color: var(--beige-100);
    --button-text-color: var(--neutral-950);
    --button-border-color: var(--beige-100);

    &:hover {
      --button-border-color: var(--neutral-400);
    }
  `,
  background_is_lighter_secondary: css`
    --button-color: var(--beige-100);
    --button-text-color: var(--beige-100);
    --button-border-color: var(--neutral-700);

    &:hover {
      --button-border-color: var(--neutral-500);
    }
  `,
}

export const buttonStyles = (
  variant: keyof typeof buttonVariants,
  theme: keyof typeof buttonTheme,
  animation: boolean,
  gap: 's' | 'm' | 'l' | 'xl' | 'full'
) => css`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: ${gap === 'full' ? 'space-between' : 'center'};
  gap: var(--gap-${gap});
  border-radius: 0;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;
  padding: 20px 22px;
  width: 100%;

  ${buttonTheme[theme]}
  ${buttonVariants[variant]}

  svg {
    width: 16px;
    height: 16px;
  }

  &:disabled {
    color: var(--neutral-550);
    cursor: not-allowed;
  }

  span,
  svg {
    z-index: 1;
  }

  @media (min-width: 768px) {
    width: auto;
  }

  @media (min-width: 768px) {
    svg {
      position: relative;
      ${animation &&
      css`
        transition: transform 0.3s ease;
      `}
    }

    &:hover {
      svg {
        ${animation &&
        css`
          transform: translateX(8px);
        `}
      }

      span {
        ${animation &&
        css`
          transition: none;
        `}
      }
    }
  }
`
